// Modules
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { CompanySelect } from 'components/forms/selects';
import { Form } from 'components/forms/form-structure';
import { TextInput, SelectInput } from 'components/forms/form-elements';
import { handleServerError } from 'utils/form-utils';
import DriveFile from 'components/models/files/drive-file';
import requiredValidation from 'utils/required-validation';


// Component
class FormForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
    templates: PropTypes.array,
    forms: PropTypes.array,
    change: PropTypes.func
  };

  constructor() {
    super();

    this.fileRenderer = this.fileRenderer.bind(this);
    this.setTitle = this.setTitle.bind(this);
  }

  setTitle(template) {
    this.props.change('title', template.name);
  }

  fileRenderer(file) {
    return <DriveFile item={file} forSelect />;
  }

  render() {
    const { initialValues, templates, forms, ...props } = this.props;
    const editing = _.get(initialValues, 'id');
    const filteredTemplates = _.filter(templates, template => _.includes(template.mimeType, 'vnd.google-apps.form'));
    const onboardingForm = _.find(forms, { title: 'Onboarding' });
    const offboardingForm = _.find(forms, { title: 'Offboarding' });

    if (onboardingForm) _.remove(filteredTemplates, { name: 'Onboarding' });
    if (offboardingForm) _.remove(filteredTemplates, { name: 'Offboarding' });

    return (
      <Form onSubmit={props.handleSubmit} {..._.pick(props, ['submitting', 'error', 'submitFailed'])}>
        { !editing &&
          <Field
            component={SelectInput}
            label="Template"
            valueKey="id"
            labelKey="name"
            name="template"
            onChangeFullValue={this.setTitle}
            optionRenderer={this.fileRenderer}
            valueRenderer={this.fileRenderer}
            options={filteredTemplates}
          />
        }
        <Field component={CompanySelect} name="company" label="Company" />
        <Field component={TextInput} name="title" label="Title" />
      </Form>
    );
  }
}

const ConnectedForm = connect((state, ownProps) => ({
  currentValues: formValueSelector(ownProps.form)(state, 'title', 'template'),
  forms: state.companies.forms,
  templates: state.pageData.templateFiles
}))(FormForm);

const ReduxForm = reduxForm({
  form: 'form-form',
  validate: (values, props) => {
    const errors = requiredValidation(['title', 'company', 'template'], values);
    const onboardingForm = _.find(props.forms, { title: 'Onboarding' });
    const offboardingForm = _.find(props.forms, { title: 'Offboarding' });

    if (onboardingForm && values.title === 'Onboarding') errors.title = 'This company already has an onboarding form';
    if (offboardingForm && values.title === 'Offboarding') errors.title = 'This company already has an offboarding form';

    return errors;
  },
  onSubmitFail: handleServerError
})(ConnectedForm);

export default connect((state) => ({
  forms: state.companies.forms
}))(ReduxForm);



// WEBPACK FOOTER //
// ./app/components/models/company/form-form.js